import { IAllocationDimension } from "helpers/allocation-dimension";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import { getColumnName } from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/utils";

export class OnlyExistingDoorsRule extends Validator<IAttributeData[], IAttributeDataError> {
    allocationDimension: IAllocationDimension;
    keyField: string;

    constructor(keyField: string, allocationDimension: IAllocationDimension) {
        super();
        this.allocationDimension = allocationDimension;
        this.keyField = keyField;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let unknownIds = [];
        const fieldName = getColumnName(model[0], this.keyField);
        if (!errors[RuleType.OnlyExistingDoorsRule] && this.allocationDimension && fieldName) {
            const ids = this.allocationDimension.dimension_values.map((it) => `${it.external_id}`);
            unknownIds = [
                ...model.reduce((acc, item) => {
                    const rowId = `${item[fieldName]}`;
                    !ids.includes(rowId) && acc.add(rowId);
                    return acc;
                }, new Set()),
            ];
        }

        const validationErrors = unknownIds.length
            ? {
                  ...errors,
                  [RuleType.OnlyExistingDoorsRule]: formatMessage(
                      "Your file contains unrecognized door ID(s): |ids|. Please remove these rows from your file.",
                      {
                          ids: unknownIds.join(", "),
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
